define(["views/common/chartjs_utils"], function (chartUtils) {
    const pieChartDatasetOptions = {
        backgroundColor: (data) => chartUtils.getChartColor(data.dataIndex),
        borderColor: "#ffffff",
    };

    const pieChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        stacked: false,
        layout: {
            padding: {
                right: 90,
                top: 40,
                left: 90,
                bottom: 40,
            },
        },
        animations: {
            outerRadius: { duration: 0 },
        },
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: chartUtils.customPieTooltip({}),
            },
            pieLabels: {
                fontSize: 14,
                lineOffsetHorizontal: 20,
            },
            pieLegend: {
                inside: true,
            }
        },
    };

    return { pieChartDatasetOptions, pieChartOptions };
});
